import React, { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

const InputField = React.forwardRef(
  (
    {
      label,
      type = "text",
      value,
      onChange,
      error,
      placeholder,
      required = false,
      icon,
      disabled = false,
    },
    ref
  ) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword);
    };

    return (
      <div className="w-full">
        <label className="mb-1.5 block text-[11px] font-semibold uppercase tracking-[0.4px] text-ui-text-muted">
          {label} {required && <span className="text-state-danger">*</span>}
        </label>
        <div className="relative">
          {icon && (
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-ui-text-subtle">
              {icon}
            </div>
          )}
          <input
            type={type === "password" && showPassword ? "text" : type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            ref={ref}
            disabled={disabled}
            className={`w-full h-11 ${icon ? "pl-10" : "pl-3"} ${
              type === "password" ? "pr-10" : "pr-3"
            } rounded-md border bg-ui-surface text-sm text-ui-text placeholder:text-ui-text-subtle transition-colors duration-150 focus:outline-none focus:border-brand ${
              error ? "border-state-danger" : "border-ui-border"
            } ${disabled ? "opacity-60 cursor-not-allowed" : ""}`}
          />
          {type === "password" && (
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-ui-text-subtle hover:text-ui-text"
            >
              {showPassword ? (
                <AiOutlineEyeInvisible size={20} />
              ) : (
                <AiOutlineEye size={20} />
              )}
            </button>
          )}
        </div>
        {error && <p className="text-state-danger text-sm mt-1">{error}</p>}
      </div>
    );
  }
);

export default InputField;
